/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sreality_Seller_NoneInputs */

const cs_sreality_seller_none = /** @type {(inputs: Sreality_Seller_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zatím není propojen jako Sreality makléř. Administrátor to může doplnit v Uživatelích, až budou uložené klíče RK.`)
};

const en_sreality_seller_none = /** @type {(inputs: Sreality_Seller_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Not linked as a Sreality seller yet. An admin can provision this from Users after the office RK keys are saved.`)
};

/**
* | output |
* | --- |
* | "Not linked as a Sreality seller yet. An admin can provision this from Users after the office RK keys are saved." |
*
* @param {Sreality_Seller_NoneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const sreality_seller_none = /** @type {((inputs?: Sreality_Seller_NoneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sreality_Seller_NoneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_sreality_seller_none(inputs)
	return cs_sreality_seller_none(inputs)
});